// extracted by mini-css-extract-plugin
export default {"fields":"touristForm-module__fields__uPmI-","mobileFields":"touristForm-module__mobileFields__3lH+V"};